var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { Button, DialogActions, TextField, Typography } from '@mui/material';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { DELETE_USER } from 'common/graphql/mutations/user/delete-user';
import DeleteButton from 'components/Buttons/Button';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { clearLoginHistory, getLoginHistoryByUserId } from 'services/user-login-history';
import { logoutUser, openSnackbar } from 'store/actions';
var DeleteUserAccountDialog = function (_a) {
    var handleClose = _a.handleClose, userId = _a.userId, userFullName = _a.userFullName;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _b = useState(''), value = _b[0], setValue = _b[1];
    var _c = useMutation(DELETE_USER), deleteUser = _c[0], loading = _c[1].loading;
    var handleDeleteUser = function () {
        deleteUser().then(function () {
            handleClose();
            dispatch(openSnackbar({
                message: t("\u0412\u0430\u0448 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u0443\u0434\u0430\u043B\u0451\u043D."),
                severity: SnackbarSeverity.INFO
            }));
            var delayDebounceFn = setTimeout(function () {
                var userLoginHistoryItems = getLoginHistoryByUserId(userId);
                if (userLoginHistoryItems && userLoginHistoryItems.length > 0) {
                    for (var _i = 0, userLoginHistoryItems_1 = userLoginHistoryItems; _i < userLoginHistoryItems_1.length; _i++) {
                        var userLoginHistory = userLoginHistoryItems_1[_i];
                        clearLoginHistory(userLoginHistory);
                    }
                }
                dispatch(logoutUser());
            }, 1500);
            return function () { return clearTimeout(delayDebounceFn); };
        }, function () {
            dispatch(openSnackbar({
                message: t("\u041E\u0448\u0438\u0431\u043A\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435 \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443."),
                severity: SnackbarSeverity.ERROR
            }));
        });
    };
    return (_jsxs("div", __assign({ className: "flex flex-col p-0 pb-20 max-w-320" }, { children: [_jsx("div", __assign({ className: "tw-dialog-header" }, { children: t('Удаление аккаунта') }), void 0), _jsx(Typography, __assign({ className: "text-16 text-center pb-20 dark:text-white" }, { children: t('Вы уверены, что хотите удалить свой аккаунт? Это действие нельзя отменить. Данные будут безвозвратно потеряны.') }), void 0), _jsx(Typography, __assign({ className: "text-16 text-center pb-20 dark:text-white" }, { children: t('Подтвердите удаление. Введите ваше полное имя в текстовое поле ниже.') }), void 0), _jsx(TextField, { disabled: true, defaultValue: userFullName, variant: "standard" }, void 0), _jsx(TextField, { value: value, onChange: function (e) {
                    setValue(e.target.value);
                } }, void 0), _jsxs(DialogActions, __assign({ className: "flex justify-between p-0" }, { children: [_jsx(Button, __assign({ variant: "text", type: "reset", onClick: handleClose }, { children: t('Отмена') }), void 0), loading ? (_jsx("div", __assign({ className: "flex items-center w-80" }, { children: _jsx(CircularProgressMui, { size: 20 }, void 0) }), void 0)) : (_jsx(DeleteButton, __assign({ onClick: handleDeleteUser, disabled: value !== userFullName, type: value !== userFullName ? 'disabled' : 'red' }, { children: t('Удалить') }), void 0))] }), void 0)] }), void 0));
};
export default DeleteUserAccountDialog;
